import { render } from "./SliderSteps.vue?vue&type=template&id=9a5664c2"
import script from "./SliderSteps.vue?vue&type=script&lang=js"
export * from "./SliderSteps.vue?vue&type=script&lang=js"

import "./SliderSteps.vue?vue&type=style&index=0&id=9a5664c2&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__